import React from 'react';
import {Container, Row} from 'reactstrap';
import * as _ from 'lodash';
import "../../MyLibrary/common.css"
import "./index.css"
import {connect} from "react-redux";
import * as actions from "../../../../actions";
import EmptyComponent from "../../../../components/empty";
import strings from "../../../../util/strings";
import ListOfMessages from "./list-of-messages";
import MessageDetail from "./message-details";
import sb from "../../../../util/sendbird";
import util from "../../../../util/messaging/utility";
import utility from "../../../../util/messaging/utility";
import api from "../../../../util/messaging/api";
import sb_util from "../../../../util/sb/util";
import CommonContainerModal from "../../../../components/modal/common-container-modal";
import NewChatTabHeaderComponent from "./new-chat/tab-header";
import NewChatTabContent from "./new-chat/tab-content";
import AttachmentModal from "../../../../components/modal/messaging/attachment-modal";
import AttachmentModalHeader from "../attachment/tab-header";
import AttachmentTabContent from "../attachment/tab-content";
import AttachmentPriceSelectionItem from "../../../../components/messaging/attachment-price-selection-item";
import ReactImageVideoLightbox from "react-image-video-lightbox";
import UserLightbox from "../attachment/user/user-lightbox";

class MessagingHomePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            broadcaster: null,
            user_type: "user",
            selectedChannel: null,
            searchText: '',
            groupChannels: [],
            isNewChatModalOpen: false,
            isAttachmentModalOpen: false,
            activeTab: 'all',

            newMessageReceived: {
                channel: null,
                message: null
            },

            fullData: [],
            lightBoxData: [],
            isLighBoxVisible: false,
            isUserLightBoxVisible: false,

            selectedItems: [],
            attachmentState: 'selection',//selection,price,preview
            currentMessage: null,
        }

    }

    componentDidMount() {


        if (window.location.pathname.indexOf("viewer") > 0) {
            util.getUserObject((userObj) => {
                this.setState({
                    user: userObj,
                    user_type: "user"
                }, () => {
                    console.log("MessagingHomePage >> user", userObj)
                    this.loginToSendBird()
                })
            });
        } else {
            util.getBroadcasterObject((broadcasterObj) => {
                this.setState({
                    broadcaster: broadcasterObj,
                    user_type: "broadcaster"
                }, () => {
                    console.log("MessagingHomePage >> broadcaster", broadcasterObj)
                    this.loginToSendBird()
                })
            });
        }

        //Receive messages through a channel event handler
        sb.sbAddChannelHandler((channel, message) => {
            console.log("MessagingHomePage >> sbAddChannelHandler", {
                channel,
                message
            })

            this.setState({
                newMessageReceived: {
                    channel,
                    message
                }
            })

            this.fetchGroupChannels();
        })
    }

    componentWillUnmount() {
        //When the UI isn't valid anymore, remove the channel event handler.
        sb.sbRemoveChannelHandler();
        //alert("sbRemoveChannelHandler")
    }

    setAttachmentState = (attachmentState) => {
        //can take values from selection,price,preview
        this.setState({
            attachmentState
        }, () => {
            if (attachmentState === "preview") {
                this.setAttachmentModal(false, "published-content", "preview");
            }
        })
    }

    setSelectedItem = (content) => {
        let selectedItems = this.state.selectedItems;

        let index = _.findIndex(selectedItems, function (currentObject) {
            return currentObject.id === content.id;
        });

        if (index === -1) {
            selectedItems.push({
                ...content,
                price: {
                    type: "free",
                    amount: 10
                }
            });
        } else {
            selectedItems = _.remove(selectedItems, function (currentObject) {
                return currentObject.id !== content.id;
            });
        }


        this.setState({
            selectedItems
        }, () => {
            console.log("selectedItems", selectedItems)
        })
    }

    fetchGroupChannels = () => {
        console.log("MessagingHomePage >> fetchGroupChannels")

        sb.sbRetrieveListOfChannels(this.state.user_type, (groupChannels) => {
            console.log("MessagingHomePage >> groupChannels", groupChannels)
            this.setState({
                groupChannels
            })
        }, () => {
            //TODO Sangam
        })
    }

    searchInListOfChannels = (query) => {
        console.log("MessagingHomePage >> searchInListOfChannels >> query = " + query)

        sb.sbSearchInListOfChannels(query, (groupChannels) => {
            console.log("MessagingHomePage >> searchInListOfChannels", groupChannels)
            this.setState({
                searchText: query,
                groupChannels
            })
        }, () => {
            //TODO Sangam
        })
    }

    updateIndividualChannel = (_channel, lastMessage) => {

        let elementsIndex = _.findIndex(this.state.groupChannels, function (channel) {
            return channel.url === _channel.url;
        });

        if (elementsIndex !== -1) {
            let newArray = [...this.state.groupChannels]
            newArray[elementsIndex] = {...newArray[elementsIndex], lastMessage: lastMessage}
            this.setState({
                groupChannels: newArray,
            });
        }
    }

    setNewChatModalOpen = (isNewChatModalOpen) => {
        this.setState({
            isNewChatModalOpen,
            activeTab: 'all'
        })
    }

    setAttachmentModal = (isAttachmentModalOpen, activeTab = 'published-content', attachmentState) => {
        this.setState({
            isAttachmentModalOpen,
            selectedItems: isAttachmentModalOpen ? [] : this.state.selectedItems,
            activeTab,
            attachmentState
        })
    }

    setUploadFromPCContent = () => {
        console.log("this.props.location", this.props.location)

        if (this.props.location.hasOwnProperty("state") &&
            this.props.location.state &&
            this.props.location.state.hasOwnProperty("selectedChannel") &&
            this.props.location.state.selectedChannel) {

            this.setSelectedChannel(this.props.location.state.selectedChannel)
            this.fetchGroupChannels();
        }

        if (this.props.location.hasOwnProperty("state") &&
            this.props.location.state &&
            this.props.location.state.hasOwnProperty("content") &&
            this.props.location.state.content) {

            this.setAttachmentModal(true, "published-content", "price");
            this.setSelectedItem(this.props.location.state.content);
        }
    }

    loginToSendBird = () => {
        let sbUserObj = sb.getSBUserObj();
        console.log("MessagingHomePage >> sbUserObj", sbUserObj)
        if (Object.keys(sbUserObj).length === 2) {
            this.fetchGroupChannels();
            this.setUploadFromPCContent();
        } else {
            sb_util.sendBirdLogin(this.state.user_type, (user) => {
                console.log("MessagingHomePage >> sendBirdLogin >> " + this.state.user_type, user)
                this.fetchGroupChannels();
                this.setUploadFromPCContent();
            }, (error) => {
                //TODO show error to the user
                console.log("MessagingHomePage >> sendBirdLogin >> user", error)
            })
        }
    }

    setSelectedChannel = (selectedChannel) => {
        this.setState({
            selectedChannel
        })
    }

    newChat = () => {
        this.setNewChatModalOpen(true);
    }

    toggleNewChatTab = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                //selectedItems: []
            });
        }
    };

    userSelectedFromNewChatList = (type, item) => {
        let from = this.state.user_type;
        let to = "user";
        if (type === "broadcaster") {
            to = "broadcaster";
        } else if (type === "all") {
            to = item.broadcaster_id === null ? "user" : "broadcaster"
        }
        util.getChatIds(from, to, item, (chatIdsArray) => {
            sb.sbCreateChannel(chatIdsArray,
                (groupChannel) => {
                    console.log("MessagingHomePage >> successCallback", JSON.stringify(groupChannel));
                    this.setNewChatModalOpen(false);
                    this.fetchGroupChannels();
                    //TODO open new message screen
                }, (error) => {
                    console.log("MessagingHomePage >> errorCallback", error)
                })
        })
    }

    updatePricingInSelectedItemsArray = (index,type,amount)=>{

        console.log("updatePricingInSelectedItemsArray", {
            index,type,amount
        })

        let selectedItems = this.state.selectedItems;

        selectedItems[index] = {
            ...selectedItems[index],
            price:{
                type,
                amount
            }
        }

        this.setState({
            selectedItems
        }, () => {
            console.log("selectedItems", selectedItems)
        })
    }

    setFullData = (fullData) => {
        this.setState({
            fullData
        })
    }

    setLightBoxData = (data) => {

        let isUserLightBoxVisible = false;
        data.map((value) => {
            if (value.url === "") {
                isUserLightBoxVisible = true;
            }
        })
        this.setState({
            lightBoxData: data,
            isLighBoxVisible: !isUserLightBoxVisible,
            isUserLightBoxVisible
        })
    }

    showLightBox = (currentMessage) => {
        this.setState({
            isLighBoxVisible: true,
            isUserLightBoxVisible:false,
            currentMessage
        })
    }

    hideLightBox = () => {
        this.setState({
            lightBoxData: [],
            isLighBoxVisible: false
        })
    }

    hideUserLightBox = () => {
        this.setState({
            fullData: [],
            isUserLightBoxVisible: false
        })
    }

    purchaseChatContent = (chat_post_id, chat_post_amount) => {
        api.purchaseChatContentAPI(this.props, chat_post_id, chat_post_amount)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps && nextProps.buy_chat_post_content && nextProps.buy_chat_post_content.hasOwnProperty("payload") && nextProps.buy_chat_post_content.payload) {
            let payload = nextProps.buy_chat_post_content.payload;

            if(payload.hasOwnProperty("success") && payload.success && payload.success.hasOwnProperty("data")){
                let data = payload.success.data;
                console.log("fetched details.....", [data])
                this.setFullData([data])
                this.setLightBoxData(utility.getLightBoxData([data]))
            } else {
                //TODO error
            }
            //clears the reducer action
            this.props.resetPostContentInChat();
        }
    }

    render() {

        const renderEmptyResults = () => {
            return (
                <EmptyComponent
                    img={strings.messaging.no_messages_found.image}
                    title={strings.messaging.no_messages_found.title}
                    description={strings.messaging.no_messages_found.description}
                    btnAction={this.newChat}
                    btnText={strings.messaging.no_messages_found.btnText}
                />
            );
        }

        return (
            <div>
                {
                    this.state.isLighBoxVisible &&
                    <div className="vuepay-react-lightbox">
                        <ReactImageVideoLightbox
                            data={this.state.lightBoxData}
                            startIndex={0}
                            showResourceCount={true}
                            onCloseCallback={() => {
                                console.log("onCloseCallback")
                                this.hideLightBox()
                            }}
                        />
                    </div>
                }

                {
                    this.state.isUserLightBoxVisible &&
                    <div className="vuepay-react-lightbox">
                        <UserLightbox
                            {...this.props}
                            history={this.props.history}
                            user={this.state.user}
                            broadcaster={this.state.broadcaster}
                            user_type={this.state.user_type}
                            selectedChannel={this.state.selectedChannel}
                            updateIndividualChannel={this.updateIndividualChannel}
                            fetchGroupChannels={this.fetchGroupChannels}
                            newMessageReceived={this.state.newMessageReceived}
                            refreshList={this.fetchGroupChannels}
                            setAttachmentModal={this.setAttachmentModal}

                            setAttachmentState={this.setAttachmentState}
                            attachmentState={this.state.attachmentState}
                            selectedItems={this.state.selectedItems}

                            showLightBox={this.showLightBox}
                            setLightBoxData={this.setLightBoxData}
                            setFullData={this.setFullData}

                            lightBoxData={this.state.fullData}
                            hideUserLightBox={this.hideUserLightBox}
                            currentMessage={this.state.currentMessage}
                            purchaseChatContent={this.purchaseChatContent}
                        />
                    </div>
                }


                <CommonContainerModal
                    isOpen={this.state.isNewChatModalOpen}
                    title={"New Chat"}
                    toggle={() => {
                        this.setNewChatModalOpen(!this.state.isNewChatModalOpen)
                    }}>

                    <Container>
                        <NewChatTabHeaderComponent activeTab={this.state.activeTab} toggle={this.toggleNewChatTab}/>
                        <NewChatTabContent activeTab={this.state.activeTab}
                                           userSelectedFromNewChatList={this.userSelectedFromNewChatList}/>
                    </Container>
                </CommonContainerModal>

                <CommonContainerModal
                    isOpen={false}
                    title={"Report User"}
                    toggle={() => {

                    }}>

                    <Container>

                    </Container>
                </CommonContainerModal>


                {
                    this.state.broadcaster &&
                    <AttachmentModal
                        isOpen={this.state.isAttachmentModalOpen}
                        toggle={() => {
                            this.setAttachmentModal(false)
                        }}
                        selectedItems={this.state.selectedItems}
                        attachmentState={this.state.attachmentState}
                        previous={() => {
                            if (this.state.attachmentState === "selection") {
                                this.setAttachmentModal(false)
                            } else if (this.state.attachmentState === "price") {
                                this.setAttachmentState("selection")
                            } else if (this.state.attachmentState === "preview") {
                                this.setAttachmentState("price")
                            }
                        }}
                        next={() => {
                            if (this.state.attachmentState === "selection") {
                                this.setAttachmentState("price")
                            } else if (this.state.attachmentState === "price") {
                                this.setAttachmentState("preview")
                            } else if (this.state.attachmentState === "preview") {
                                //send to user
                            }
                        }}
                    >
                        {
                            this.state.attachmentState === "selection"
                                ?
                                <Container>
                                    <AttachmentModalHeader activeTab={this.state.activeTab}
                                                           toggle={this.toggleNewChatTab}/>
                                    <AttachmentTabContent
                                        activeTab={this.state.activeTab}
                                        broadcaster={this.state.broadcaster}
                                        selectedItems={this.state.selectedItems}
                                        setSelectedItem={this.setSelectedItem}
                                    />
                                </Container>
                                :
                                <Container>
                                    {
                                        this.state.selectedItems.map((content, index) => {
                                            return (
                                                <AttachmentPriceSelectionItem
                                                    content={content}
                                                    index={index}
                                                    updatePricingInSelectedItemsArray={this.updatePricingInSelectedItemsArray}
                                                />
                                            )
                                        })
                                    }
                                </Container>
                        }
                    </AttachmentModal>
                }


                <CommonContainerModal
                    isOpen={this.state.isNewChatModalOpen}
                    title={"New Chat"}
                    toggle={() => {
                        this.setNewChatModalOpen(!this.state.isNewChatModalOpen)
                    }}>

                    <Container>
                        <NewChatTabHeaderComponent activeTab={this.state.activeTab} toggle={this.toggleNewChatTab}/>
                        <NewChatTabContent activeTab={this.state.activeTab} userSelectedFromNewChatList={this.userSelectedFromNewChatList}/>
                    </Container>
                </CommonContainerModal>

                <main role="main" className="">
                    <div className="broadcast-container-parent row">
                        <div className="margin-auto">
                            <Container className="chats-home-container no-padding">
                                {
                                    (this.state.groupChannels ===null || (this.state.groupChannels && this.state.groupChannels.length === 0 && this.state.searchText.length === 0)) ?
                                        renderEmptyResults()
                                        :
                                        <Row>
                                            <ListOfMessages
                                                user={this.state.user}
                                                broadcaster={this.state.broadcaster}
                                                user_type={this.state.user_type}
                                                groupChannels={this.state.groupChannels}
                                                setSelectedChannel={this.setSelectedChannel}
                                                setNewChatModalOpen={this.setNewChatModalOpen}
                                                searchInListOfChannels={this.searchInListOfChannels}
                                            />
                                            <MessageDetail
                                                history={this.props.history}
                                                user={this.state.user}
                                                broadcaster={this.state.broadcaster}
                                                user_type={this.state.user_type}
                                                selectedChannel={this.state.selectedChannel}
                                                updateIndividualChannel={this.updateIndividualChannel}
                                                fetchGroupChannels={this.fetchGroupChannels}
                                                newMessageReceived={this.state.newMessageReceived}
                                                refreshList={this.fetchGroupChannels}
                                                setAttachmentModal={this.setAttachmentModal}

                                                setAttachmentState={this.setAttachmentState}
                                                attachmentState={this.state.attachmentState}
                                                selectedItems={this.state.selectedItems}

                                                showLightBox={this.showLightBox}
                                                setLightBoxData={this.setLightBoxData}
                                                setFullData={this.setFullData}
                                            />
                                        </Row>
                                }

                            </Container>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        get_all_users: state.get_all_users,
        flag: state.flag,
        buy_chat_post_content:state.buy_chat_post_content,
        moneyblox: state.moneyblox,
    };
}

export default connect(mapStateToProps, actions)(MessagingHomePage);